import React from "react";
import luciPic from "../luci.png";

const BackPage = () => {
  return (
    <div className="back-page">
      <div className="luci">
        <img src={luciPic} width={300} alt="luci the dog" />
      </div>
      <p>Idea by sarahdear</p>
      <p>Copyright &copy; 2021 - {new Date().getFullYear()}, Pseudosaurus</p>
    </div>
  );
};

export default BackPage;
